var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.background)?_c(_vm.backgroundComponent,{tag:"component"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }